import * as yup from 'yup';

export const RelativeCareSchema = yup.object({
  description: yup.string().required(),
  expiryDate: yup.date().notRequired().nullable(),
});

export interface IRelativeCare {
  description: string;
  expiryDate: Date;
}

export const UpdateRelativeCareSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(RelativeCareSchema);

export interface IUpdateRelativeCare extends IRelativeCare {
  id: string;
}
